export const GitbookLinks = {
  PREMIUM_LINK: 'https://kakaobusiness.gitbook.io/main/ad/searchad/keywordad',
  PREMIUM_LINK_REGISTRATION:
    'https://kakaobusiness.gitbook.io/main/ad/searchad/keywordad/ad-audit/registration#undefined-7',
  TALK_CHANNEL:
    'https://kakaobusiness.gitbook.io/main/ad/searchad/channelsearch',
  TALK_CHANNEL_REGISTRATION:
    'https://kakaobusiness.gitbook.io/main/ad/searchad/channelsearch/ad-audit/registration#id-1.-2',
  TALK_CHANNEL_INDUSTRY:
    'https://kakaobusiness.gitbook.io/main/ad/searchad/channelsearch/ad-audit/industry-guide',
}
